import {
  ProjectLedgerFilters,
  ProjectLedgerRow,
  ProjectLedgerSummary,
} from '../../api/incomeExpenseApi';
import * as XLSX from 'xlsx';
import { sanitizeExportFilename } from '../../utils/excelExport';

const formatExportDateTime = (value: string) => new Date(value).toLocaleString('vi-VN');

const formatApartment = (row: ProjectLedgerRow) => {
  if (!row.apartmentCode) return '';
  return row.apartmentCustomerCode
    ? `${row.apartmentCode} (${row.apartmentCustomerCode})`
    : row.apartmentCode;
};

const voucherDisplayName = (row: ProjectLedgerRow) => {
  const parts = [row.voucherName];
  if (row.voucherReceiptRef) parts.push(row.voucherReceiptRef);
  return parts.join(' — ');
};

export const PROJECT_LEDGER_EXPORT_HEADERS = [
  'Ngày',
  'Người thực hiện',
  'Loại',
  'Tên phiếu',
  'Căn hộ',
  'Dự thu',
  'Dự chi',
  'Ngân hàng thu',
  'Ngân hàng chi',
  'Tiền mặt thu',
  'Tiền mặt chi',
  'Diễn giải',
];

export function mapProjectLedgerRowsToExportData(rows: ProjectLedgerRow[]): (string | number)[][] {
  return rows.map((row) => [
    formatExportDateTime(row.actualDate),
    row.performerName || '',
    row.typeName,
    voucherDisplayName(row),
    formatApartment(row),
    row.expectedIncome,
    row.expectedExpenditure,
    row.bankIncome,
    row.bankExpense,
    row.cashIncome,
    row.cashExpense,
    row.description || '',
  ]);
}

export function exportProjectAccountLedgerReport(params: {
  accountName: string;
  buildingName: string;
  filters: ProjectLedgerFilters;
  rows: ProjectLedgerRow[];
  summary: ProjectLedgerSummary;
  openingBank: number;
  openingCash: number;
  closingBank: number;
  closingCash: number;
}): void {
  const {
    accountName,
    buildingName,
    filters,
    rows,
    summary,
    openingBank,
    openingCash,
    closingBank,
    closingCash,
  } = params;

  const dataRows = mapProjectLedgerRowsToExportData(rows);
  dataRows.push([
    'Tổng cộng',
    '',
    '',
    '',
    '',
    summary.expectedIncome,
    summary.expectedExpenditure,
    summary.bankIncome,
    summary.bankExpense,
    summary.cashIncome,
    summary.cashExpense,
    '',
  ]);

  const metaRows: (string | number)[][] = [
    ['CHI TIẾT THU CHI', accountName],
    ['Tòa nhà', buildingName],
    [
      'Kỳ báo cáo',
      filters.dateFrom && filters.dateTo
        ? `${filters.dateFrom} — ${filters.dateTo}`
        : filters.dateFrom || filters.dateTo || 'Tất cả',
    ],
    ['Đầu kỳ — Ngân hàng', openingBank, 'Tiền mặt', openingCash],
    ['Cuối kỳ — Ngân hàng', closingBank, 'Tiền mặt', closingCash],
    [],
  ];

  const fromPart = filters.dateFrom || 'all';
  const toPart = filters.dateTo || 'all';
  const filename = `${sanitizeExportFilename(
    `chi-tiet-thu-chi_${buildingName}_${accountName}_${fromPart}_${toPart}`,
  )}.xlsx`;

  const sheetRows = [...metaRows, PROJECT_LEDGER_EXPORT_HEADERS, ...dataRows];
  const ws = XLSX.utils.aoa_to_sheet(sheetRows);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Chi tiết thu chi'.substring(0, 31));
  const buffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  link.click();
  URL.revokeObjectURL(link.href);
}
